import { render, staticRenderFns } from "./FreeSpace.vue?vue&type=template&id=1af2249a&"
import script from "./FreeSpace.vue?vue&type=script&lang=js&"
export * from "./FreeSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports